import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import WaveUIForm_V2 from '@/shared/components/forms/WaveUIForm_V2';
import FieldType from '@/shared/components/forms/WaveUIForm_V2/types/fieldType.enum';
import regexpPatterns from '@/shared/constants/regexpPatterns';

type AccountDetailsFormProps = {
  formValues: Record<string, unknown>;
  errors: Record<string, string>;
  setFormValues: (value: Record<string, unknown>) => void;
  setFormErrors: (value: Record<string, string>) => void;
};

const AccountDetailsForm: FC<AccountDetailsFormProps> = ({
  formValues,
  errors,
  setFormValues,
  setFormErrors,
}) => {
  const { t } = useTranslation(['customers', 'common']);

  const onValidate = (fieldName: string) => {
    const newErrors = { ...errors };

    if (fieldName === 'first_name') {
      !formValues.first_name
        ? (newErrors.first_name = t('customers:first_name_required'))
        : (newErrors.first_name = '');
    }

    if (fieldName === 'last_name') {
      !formValues.last_name
        ? (newErrors.last_name = t('customers:last_name_required'))
        : (newErrors.last_name = '');
    }

    if (fieldName === 'email_address') {
      if (!formValues.email_address) {
        newErrors.email_address = t('customers:email_address_required');
      } else if (
        !regexpPatterns.emailValidator.test(formValues.email_address as string)
      ) {
        newErrors.email_address = t('customers:invalid_email_address');
      } else {
        newErrors.email_address = '';
      }
    }

    if (fieldName === 'phone_number') {
      if (!formValues.phone_number) {
        newErrors.phone_number = t('customers:phone_required');
      } else if (
        !regexpPatterns.phoneNumberValidator.test(
          formValues.phone_number as string,
        )
      ) {
        newErrors.phone_number = t('customers:invalid_phone');
      } else {
        newErrors.phone_number = '';
      }
    }

    setFormErrors(newErrors);
  };

  return (
    <WaveUIForm_V2
      fields={[
        {
          columns: 6,
          field_type: FieldType.Text,
          field_props: {
            name: 'first_name',
            label: t('customers:firstName'),
            placeholder: t('customers:firstName'),
            error: !!errors.first_name,
            helperText: errors.first_name,
            value: formValues.first_name as string,
            required: true,
            onBlur: () => onValidate('first_name'),
          },
        },
        {
          columns: 6,
          field_type: FieldType.Text,
          field_props: {
            name: 'last_name',
            label: t('customers:lastName'),
            placeholder: t('customers:lastName'),
            error: !!errors.last_name,
            helperText: errors.last_name,
            value: formValues.last_name as string,
            required: true,
            onBlur: () => onValidate('last_name'),
          },
        },
        {
          field_type: FieldType.Text,
          field_props: {
            name: 'email_address',
            label: t('customers:emailAddress'),
            placeholder: t('customers:emailAddress'),
            error: !!errors.email_address,
            helperText: errors.email_address,
            value: formValues.email_address as string,
            required: true,
            onBlur: () => onValidate('email_address'),
          },
        },
        {
          field_type: FieldType.Text,
          field_props: {
            name: 'phone_number',
            label: t('customers:phoneNumber'),
            placeholder: t('customers:phoneNumber'),
            error: !!errors.phone_number,
            helperText: errors.phone_number,
            value: formValues.phone_number as string,
            required: true,
            onBlur: () => onValidate('phone_number'),
          },
        },
      ]}
      getFieldsValues={(value) => {
        setFormValues({ ...formValues, ...value });
      }}
    />
  );
};

export default AccountDetailsForm;
